export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const FETCH_USER_DETAILS = 'FETCH_USER_DETAILS';

export const GET_WISHLIST_DATA = 'GET_WISHLIST_DATA';
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST';

export const GET_CART_DATA = 'GET_CART_DATA';
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const CLEAR_CART = 'CLEAR_CART';

export const PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH';
export const PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW';
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS';
export const SEARCH_KEYWORD_REQUEST = 'SEARCH_KEYWORD_REQUEST';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const EXCLUDE_OUT_OF_STOCK = 'EXCLUDE_OUT_OF_STOCK';

export const PRODUCTS_LIST_SUCCESS = 'PRODUCTS_LIST_SUCCESS';
export const PRODUCTS_LIST_FAILURE = 'PRODUCTS_LIST_FAILURE';
export const PRODUCTS_LIST_REQUEST = 'PRODUCTS_LIST_REQUEST';
export const PRODUCTS_DETAILS_REQUEST = 'PRODUCTS_DETAILS_REQUEST';
export const PRODUCTS_DETAILS_SUCCESS = 'PRODUCTS_DETAILS_SUCCESS';
export const PRODUCTS_DETAILS_FAILURE = 'PRODUCTS_DETAILS_FAILURE';